<template>
	<div class="toTop" v-if="isShowToTop && !$route.meta.hideScrollTop" @click="scrollToTop">
		<i class="iconfont icon-huidaodingbu"></i>
		<div class="text">回到顶部</div>
	</div>
</template>

<script>
	export default {
		name: 'scrollToTop',
		data() {
			return {
				scrollTop: 0,
				isShowToTop: false
			}
		},
		mounted() {
			this.scrollContainer = document.querySelector('.mainOverflowY')
			if (this.scrollContainer) {
			
				this.scrollContainer.addEventListener('scroll', this.handleScroll)
			}
		},
		beforeDestroy() {

			if (this.scrollContainer) {
				this.scrollContainer.removeEventListener('scroll', this.handleScroll)
			}
		},
		methods: {
			handleScroll() {
				this.scrollTop = this.scrollContainer.scrollTop
			
				this.isShowToTop = this.scrollTop > 500
			},
			scrollToTop() {
				this.scrollContainer.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.toTop {
		color: #8C8C8C;
		cursor: pointer;
		text-align: center;
		letter-spacing: 0;
		font-size: 12px;
		transition: all 0.3s;
		transform: scale(0.8);
	
		.icon-huidaodingbu {
			background: linear-gradient(135deg, #4BCAFF 0%, #1A71FF 100%);
			background-clip: text;
			color: transparent;
			font-size: 38px;
		}
	
		&:hover {
			color: #0D68FF;
		}
	}
</style>